<template>
    <div>
        <div class="table-control"
             v-for="(offer, offerIndex) in action.bumpOffers"
             :class="{'stack-m': isNotLastVersion(offerIndex)}"
             :key="offerIndex">
            <h3 class="stack-s">Version {{offer.name}}</h3>
            <table>
                <tbody>
                <tr v-for="(line, lineIndex) in lines" :key="lineIndex">
                    <td><strong class="text-muted">{{line[0]}}</strong></td>
                    <td>{{line[1](offer)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';
    import listSummary from '@/common/helpers/list-summary';
    import LANGUAGES from '@/data/languages';

    export default {
        name: 'offer-purchase-bump-summary',
        extends: BaseActionSummary,
        data() {
            return {
                lines: [
                    [
                        'Bump Amount', v => v.bumpAmount,
                    ],
                    [
                        'Bonus Amount', v => v.bonusAmount,
                    ],
                    [
                        'Content',
                        ({choices}) => listSummary(choices.map(v => this.getLangName(v)), 3),
                    ],
                ],
            };
        },
        methods: {
            getLangName({langIso}) {
                const result = LANGUAGES.find(v => v.langIso === langIso);
                if (result) {
                    return result.name;
                }
                return '?';
            },
            isNotLastVersion(index) {
                return index !== this.action.bumpOffers.length - 1;
            },
        },
    };
</script>
